import { Button } from "monday-ui-react-core";
import styled from "styled-components";

const CloneButtonWrapper = styled.div`
  box-sizing: border-box;
  padding-top: 0;
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
  width: 100%;
`;
const CloneButton = styled(Button)`
  margin-top: 20px;
  float: right;
`;
interface CloneItemsButtonProps {
  isDisabled: boolean;
  onCloneItemButtonClick: () => void;
}

export function CloneItemsButton({ isDisabled, onCloneItemButtonClick }: CloneItemsButtonProps) {
  return (
    <CloneButtonWrapper>
      <CloneButton kind={Button.kinds.PRIMARY} onClick={() => onCloneItemButtonClick()} disabled={isDisabled}>
        Clone item(s)
      </CloneButton>
    </CloneButtonWrapper>
  );
}
